import { create } from 'zustand';

type Store = {
  isLoggedIn: boolean;
  isLoggedOutModalOn: boolean;
  setIsLoggedIn: (value: boolean) => void;
  setIsLoggedOutModalOn: (value: boolean) => void;
};

export const useAuthorizationStore = create<Store>()((set) => ({
  isLoggedIn: true,
  isLoggedOutModalOn: false,
  setIsLoggedIn: (value: boolean) => set(() => ({ isLoggedIn: value })),
  setIsLoggedOutModalOn: (value: boolean) => set(() => ({ isLoggedOutModalOn: value })),
}));
